export const detailOrder = {
  path: "/detail-order",
  name: "detailOrder",
  hidden: true,
  component: () => import("@/components/buyMedicine/components/detailOrder"),
  meta: {
    title: "Detail Pesanan",
    icon: "fa-capsules",
    roles: ["administrator", "member"]
  }
};
export default detailOrder;



// WEBPACK FOOTER //
// ./src/router/modules/detailOrder.js